var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import styles from './HomePage.module.scss';
import ChatInfo from "./ChatInfo";
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import InputComponent from "../../InputComponent/InputComponent";
import { createObjectChannel, globalSearch } from "../../utils/utils";
import ChannelInfo from "./ChannelInfo";
import { setChat } from "../../store/slices/setChatIDSlice";
import { setTempChat } from "../../store/slices/appSlice";
import { useChannelClickHandler } from "../../hooks/useHandleClickToChannel";
import DialogComponent, { ConfirmComponent, NotFoundChat } from "../Settings/DialogComponent";
import { channelAPI, messagesAPI } from "../../API/api";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
const ListComponent = ({ list }) => {
    return (list.map((item) => {
        if ("channel" in item) {
            return (_jsx(ChannelInfo, Object.assign({}, item), item.chatID + 'global'));
        }
        else {
            return (_jsx(ChatInfo, Object.assign({}, item), item.uid + 'global'));
        }
    }));
};
const TempChatComponent = () => {
    const tempChat = useAppSelector(state => state.app.tempChat);
    const selectedChat = useAppSelector(state => state.app.selectedChat);
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (tempChat && (selectedChat === null || selectedChat === void 0 ? void 0 : selectedChat.uid) !== tempChat.uid) {
            dispatch(setTempChat(null));
        }
    }, [selectedChat]);
    return (_jsx(_Fragment, { children: tempChat && _jsx(TempChat, { tempChat: tempChat }) }));
};
const TempChat = ({ tempChat }) => {
    const chatList = useAppSelector(state => state.app.chatsList);
    const dispatch = useAppDispatch();
    const currentUser = useAppSelector(state => state.app.currentUser);
    const [isNotAccess, setIsNotAccess] = useState(false);
    const [notFoundChannel, setNotFoundChannel] = useState(false);
    const { t } = useTypedTranslation();
    const isChannel = !!(tempChat === null || tempChat === void 0 ? void 0 : tempChat.channel);
    const currentComponent = isChannel ? _jsx(ChannelInfo, Object.assign({}, tempChat)) : _jsx(ChatInfo, Object.assign({}, tempChat));
    const { handleClickToChannel } = useChannelClickHandler({ isSelected: false, channel: tempChat.channel, currentUserID: currentUser.uid, setIsNotAccess, setNotFoundChannel });
    const sendRequest = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        console.log('send a request');
        yield channelAPI.applyForMembership(currentUser, (_a = tempChat.channel) === null || _a === void 0 ? void 0 : _a.channelID);
        setIsNotAccess(false);
    });
    const unsubscribe = () => {
        if (isChannel) {
            messagesAPI.deleteChat(currentUser, createObjectChannel(tempChat.channel))
                .catch((err) => {
                console.log('Канал удалён', err);
                dispatch(setTempChat(null));
            })
                .finally(() => setNotFoundChannel(false));
        }
    };
    useEffect(() => {
        if (tempChat) {
            const isChatList = chatList.some((item) => item.uid === (isChannel ? tempChat.channel.channelID : tempChat.uid));
            isChannel ?
                handleClickToChannel()
                :
                    dispatch(setChat({ currentUser: currentUser, guestInfo: tempChat }));
            if (isChatList)
                dispatch(setTempChat(null));
        }
    }, [tempChat, chatList]);
    if (isNotAccess)
        return (_jsx(DialogComponent, { onClose: setIsNotAccess, isOpen: isNotAccess, children: _jsx(ConfirmComponent, { confirmFunc: sendRequest, handleClose: () => setIsNotAccess(false), text: t("notificationClosedCommunity") }) }));
    if (notFoundChannel)
        return (_jsx(DialogComponent, { isOpen: notFoundChannel, onClose: unsubscribe, children: _jsx(NotFoundChat, { confirmFunc: unsubscribe, user: !isChannel }) }));
    return (_jsx(_Fragment, { children: currentComponent }));
};
const ChatList = () => {
    const [name, setName] = useState('');
    const [globalSearchUsers, setGlobalSearchUsers] = useState([]);
    const myChats = useAppSelector(state => state.app.chatsList);
    const currentUserID = useAppSelector(state => state.app.currentUser.uid);
    const { t } = useTypedTranslation();
    useEffect(() => {
        if (name) {
            const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
                const response = yield globalSearch(name, currentUserID);
                setGlobalSearchUsers(response);
            });
            fetchData();
        }
    }, [name]);
    const filterMyChats = useMemo(() => {
        if (!name)
            return [...myChats].filter(item => { var _a; return (_a = item.displayName) === null || _a === void 0 ? void 0 : _a.includes(name); });
    }, [name, myChats]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: styles.item, children: _jsx(InputComponent, { classes: styles.blockInput, returnValue: setName, inputProps: { maxLength: 16 }, isCleanIcon: true }) }), _jsx("div", { style: { height: 'calc(100% - 102px)' }, children: _jsxs("ul", { className: styles.chatList, children: [_jsx(TempChatComponent, {}), name.length ?
                            _jsx(ListComponent, { list: globalSearchUsers })
                            :
                                _jsx(ListComponent, { list: filterMyChats }), name && globalSearchUsers.length === 0 &&
                            _jsx("li", { className: styles.chatInfo, children: t('nothingFound') })] }) })] }));
};
export default ChatList;
